import BaseModel from '../base/BaseModel.model';
import TipoEvaluacion from '../evaluacion/tipoEvaluacion.model';
import AnnoucementEvaluationType from './annoucementEvaluationType.Model';

export default class AnnoucementRequiredEvaluationType extends BaseModel {
    
    public annoucementEvaluationTypeId: number;
    public evaluationTypeId: number;
    public evaluationType: TipoEvaluacion = new TipoEvaluacion();
    //public annoucementEvaluationType: AnnoucementEvaluationType = new AnnoucementEvaluationType();

    constructor(){
        super();
        this.init();
    }

    init(){
        this.evaluationTypeId = 0;
        this.annoucementEvaluationTypeId = 0;
    }
}